export const translations: Record<string, any> = {
  en: {
    dashboard: "Dashboard",
    notifications: "Notifications",
    kyc_verification: "KYC Verification",
    digital_agreement: "Digital Agreement",
    earnings: "Earnings",
    settings: "Settings",
    account_active: "Account Active",
    terminal_access: "Terminal Access",
    locked: "Locked",
    granted: "Granted",
    make_payment: "Make Payment",
    payout_request: "Payout Request",
    support: "Support",
    logout: "Logout",
    account_status: "Account Status",
    document_status: "Document Status",
    agreement_status: "Agreement Status",
    payment_status: "Payment Status",
    support_audit: "Support Audit",
    status_active: "ACTIVE",
    status_pending: "PENDING",
    status_signed: "SIGNED",
    status_success: "SUCCESS",
    status_unlocked: "UNLOCKED",
    status_locked: "LOCKED"
  },
  hi: {
    dashboard: "डैशबोर्ड",
    notifications: "सूचनाएं",
    kyc_verification: "केवाईसी सत्यापन",
    digital_agreement: "डिजिटल समझौता",
    earnings: "कमाई",
    settings: "सेटिंग्स",
    account_active: "खाता सक्रिय",
    terminal_access: "टर्मिनल एक्सेस",
    locked: "लॉक किया गया",
    granted: "स्वीकृत",
    make_payment: "भुगतान करें",
    payout_request: "भुगतान का अनुरोध",
    support: "सहायता",
    logout: "लॉगआउट",
    account_status: "खाता स्थिति",
    document_status: "दस्तावेज़ स्थिति",
    agreement_status: "समझौता स्थिति",
    payment_status: "भुगतान स्थिति",
    support_audit: "सहायता ऑडिट",
    status_active: "सक्रिय",
    status_pending: "लंबित",
    status_signed: "हस्ताक्षरित",
    status_success: "सफल",
    status_unlocked: "अनलॉक",
    status_locked: "लॉक"
  },
  te: {
    dashboard: "డ్యాష్‌బోర్ਡ",
    notifications: "నోటిఫికేషన్లు",
    kyc_verification: "KYC ధృవీకరణ",
    digital_agreement: "డిజిటల్ ఒప్పందం",
    earnings: "సంపాదన",
    settings: "సెట్టింగులు",
    account_active: "ఖాతా యాక్టివ్",
    terminal_access: "టెర్మినల్ యాక్సెస్",
    locked: "లాక్ చేయబడింది",
    granted: "అనుమతించబడింది",
    make_payment: "చెల్లింపు చేయండి",
    payout_request: "చెల్లింపు అభ్యర్థన",
    support: "మద్దతు",
    logout: "నిష్క్రమించు",
    account_status: "ఖాతా స్థితి",
    document_status: "పత్రాల స్థితి",
    agreement_status: "ఒప్పందం స్థితి",
    payment_status: "చెల్లింపు స్థితి",
    support_audit: "మద్దతు ఆడిట్",
    status_active: "యాക്టివ్",
    status_pending: "పెండింగ్",
    status_signed: "సంతకం చేయబడింది",
    status_success: "విజయం",
    status_unlocked: "అన్‌లాక్",
    status_locked: "లాਕ"
  },
  kn: {
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    notifications: "ಅಧಿಸೂಚನೆಗಳು",
    kyc_verification: "ಕೆವೈಸಿ ಪರಿಶೀಲನೆ",
    digital_agreement: "ಡಿಜಿಟಲ್ ಒಪ್ಪಂದ",
    earnings: "ಗಳಿಕೆಗಳು",
    settings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    account_active: "ಖಾತೆ ಸಕ್ರಿಯವಾಗಿದೆ",
    terminal_access: "ಟರ್ಮಿನಲ್ ಪ್ರವೇಶ",
    locked: "ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
    granted: "ಅನುಮತಿಸಲಾಗಿದೆ",
    make_payment: "ಪಾವತಿ ಮಾಡಿ",
    payout_request: "ಪಾವತಿ ವಿನಂತಿ",
    support: "ಬೆಂಬಲ",
    logout: "ನಿರ್ಗಮಿಸು",
    account_status: "ಖಾತೆ ಸ್ಥಿತಿ",
    document_status: "ದಾಖಲೆ ಸ್ಥಿತಿ",
    agreement_status: "ಒಪ್ಪಂದದ ಸ್ಥಿತಿ",
    payment_status: "ಪಾವತಿ ಸ್ಥಿತಿ",
    support_audit: "ಬೆಂಬಲ ಆಡಿಟ್",
    status_active: "ಸಕ್ರಿಯ",
    status_pending: "ಬಾಕಿ ಇದೆ",
    status_signed: "ಸಹಿದಾರಿತ",
    status_success: "ಯಶಸ್ಸು",
    status_unlocked: "ಅನ್‌ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
    status_locked: "ಲಾಕ್ ಮಾಡಲಾಗಿದೆ"
  },
  ta: {
    dashboard: "டாஷ்போர்டு",
    notifications: "அறிவிப்புகள்",
    kyc_verification: "கேஒய்சி சரிபார்ப்பு",
    digital_agreement: "டிஜிட்டல் ஒப்பந்தம்",
    earnings: "வருவாய்",
    settings: "அமைப்புகள்",
    account_active: "கணக்கு செயலில் உள்ளது",
    terminal_access: "டெர்மினல் அணுகல்",
    locked: "பூட்டப்பட்டது",
    granted: "அனுமதிக்கப்பட்டது",
    make_payment: "பணம் செலுத்துக",
    payout_request: "பணம் எடுப்பு கோரிக்கை",
    support: "ஆதரவு",
    logout: "வெளியேறு",
    account_status: "கணக்கு நிலை",
    document_status: "ஆவண நிலை",
    agreement_status: "ஒப்பந்த நிலை",
    payment_status: "பண நிலை",
    support_audit: "ஆதரவு தணிக்கை",
    status_active: "செயலில்",
    status_pending: "நிலுவையில்",
    status_signed: "கையெழுத்திடப்பட்டது",
    status_success: "வெற்றி",
    status_unlocked: "திறக்கப்பட்டது",
    status_locked: "பூட்டப்பட்டது"
  },
  ml: {
    dashboard: "ಡಾഷ്‌ബോർഡ്",
    notifications: "അറിയിപ്പുകൾ",
    kyc_verification: "കെവൈസി പരിശോധന",
    digital_agreement: "ഡിജിറ്റൽ കരാർ",
    earnings: "വരുമാനം",
    settings: "ക്രമീകരണങ്ങൾ",
    account_active: "അക്കൗണ്ട് സജീവം",
    terminal_access: "ടെർമിനൽ ആക്സസ്",
    locked: "പൂട്ടിയിരിക്കുന്നു",
    granted: "അനുവദിച്ചു",
    make_payment: "പേയ്‌മെന്റ് നടത്തുക",
    payout_request: "പേഔട്ട് അഭ്യർത്ഥന",
    support: "പിന്തുണ",
    logout: "ലോഗ് ഔട്ട്",
    account_status: "അക്കൗണ്ട് നില",
    document_status: "രേഖകളുടെ നില",
    agreement_status: "കരാർ നില",
    payment_status: "പേയ്‌മെന്റ് നില",
    support_audit: "പിന്തുണ ഓഡിറ്റ്",
    status_active: "സജീവം",
    status_pending: "പെൻഡിംഗ്",
    status_signed: "ഒപ്പിട്ടു",
    status_success: "വിജയം",
    status_unlocked: "അൺലോക്ക് ചെയ്തു",
    status_locked: "പൂട്ടിയിരിക്കുന്നു"
  },
  mr: {
    dashboard: "डॅशबोर्ड",
    notifications: "सूचना",
    kyc_verification: "केवायसी पडताळणी",
    digital_agreement: "डिजिटल करार",
    earnings: "कमाई",
    settings: "सेटिंग्ज",
    account_active: "खाते सक्रिय",
    terminal_access: "टर्मिनल प्रवेश",
    locked: "लॉक केले",
    granted: "मंजूर",
    make_payment: "पेमेंट करा",
    payout_request: "पेआउट विनंती",
    support: "मदत",
    logout: "लॉगआउट",
    account_status: "खाते स्थिती",
    document_status: "दस्तऐवज स्थिती",
    agreement_status: "करार स्थिती",
    payment_status: "पेमेंट स्थिती",
    support_audit: "मदत ऑडिट",
    status_active: "सक्रिय",
    status_pending: "प्रलंबित",
    status_signed: "स्वाक्षरीकृत",
    status_success: "यशस्वी",
    status_unlocked: "अनलॉक",
    status_locked: "लॉक"
  },
  bn: {
    dashboard: "ড্যাশবোর্ড",
    notifications: "বিজ্ঞপ্তি",
    kyc_verification: "কেওয়াইসি যাচাইকরণ",
    digital_agreement: "ডিজিটাল চুক্তি",
    earnings: "উপার্জন",
    settings: "সেটিংস",
    account_active: "অ্যাক্টিভ অ্যাকাউন্ট",
    terminal_access: "টার্মিনাল অ্যাক্সেস",
    locked: "লকড",
    granted: "অনুমোদিত",
    make_payment: "পেমেন্ট করুন",
    payout_request: "পেআউট অনুরোধ",
    support: "সহায়তা",
    logout: "লগআউট",
    account_status: "অ্যাকাউন্ট স্ট্যাটাস",
    document_status: "ডকুমেন্ট স্ট্যাটাস",
    agreement_status: "চুক্তি স্ট্যাটাস",
    payment_status: "পেমেন্ট স্ট্যাটাস",
    support_audit: "সহায়তা অডিট",
    status_active: "সক্রিয়",
    status_pending: "পেন্ডিং",
    status_signed: "স্বাক্ষরিত",
    status_success: "সফল",
    status_unlocked: "আনলকড",
    status_locked: "লকড"
  },
  gu: {
    dashboard: "ડેશબોર્ડ",
    notifications: "સૂચનાઓ",
    kyc_verification: "કેવાયસી ચકાસણી",
    digital_agreement: "ડિજિટલ કરાર",
    earnings: "કમાણી",
    settings: "સેટિંગ્સ",
    account_active: "ખાતું સક્રિય છે",
    terminal_access: "ટર્મિનલ ઍક્સેસ",
    locked: "લૉક કરેલ",
    granted: "મંજૂર",
    make_payment: "ચુકવણી કરો",
    payout_request: "પેઆઉટ વિનંતી",
    support: "સપોર્ટ",
    logout: "લોગઆઉટ",
    account_status: "ખાતાની સ્થિતિ",
    document_status: "દસ્તાવેજ સ્થિતિ",
    agreement_status: "કરાર સ્થિતિ",
    payment_status: "ચુકવણી સ્થિતિ",
    support_audit: "સપોર્ટ ઓડિટ",
    status_active: "સક્રિય",
    status_pending: "બાકી",
    status_signed: "હસ્તાક્ષરિત",
    status_success: "સફળ",
    status_unlocked: "અનલૉક",
    status_locked: "લૉક કરેલ"
  },
  pa: {
    dashboard: "ਡੈਸ਼ਬੋਰਡ",
    notifications: "ਨੋਟੀਫਿਕੇਸ਼ਨ",
    kyc_verification: "ਕੇਵਾਈਸੀ ਵੈਰੀਫਿਕੇਸ਼ਨ",
    digital_agreement: "ਡਿਜੀਟਲ ਸਮਝੌਤਾ",
    earnings: "ਕਮਾਈ",
    settings: "ਸੈਟਿੰਗਾਂ",
    account_active: "ਖਾਤਾ ਸਰਗਰਮ",
    terminal_access: "ਟਰਮੀਨਲ ਐਕਸੈਸ",
    locked: "ਲੌਕ ਕੀਤਾ",
    granted: "ਮਨਜ਼ੂਰ",
    make_payment: "ਭੁగਤាន ਕਰੋ",
    payout_request: "ਪੇਆਉਟ ਬੇਨਤੀ",
    support: "ਸਹਾਇਤਾ",
    logout: "ਲੌਗਆਉਟ",
    account_status: "ਖਾਤਾ ਸਥਿਤੀ",
    document_status: "ਦਸਤਾਵੇਜ਼ ਸਥਿਤੀ",
    agreement_status: "ਸਮਝੌਤਾ ਸਥਿਤੀ",
    payment_status: "ਭੁਗਤਾਨ ਸਥਿਤੀ",
    support_audit: "ਸਹਾਇਤਾ ਆਡਿਟ",
    status_active: "ਸਰਗਰਮ",
    status_pending: "ਲੰਬਿਤ",
    status_signed: "ਦਸਤਖਤ ਕੀਤੇ",
    status_success: "ਸਫਲ",
    status_unlocked: "ਅਨਲੌਕ",
    status_locked: "ਲੌਕ"
  }
};
